export default "<div class=\"container\">\n  <h1>Human Resources Center</h1>\n</div>\n"